import React from "react";
import {getButtonClasses} from "../inputUtility";

interface ButtonFactoryProps {
    className?: string;
    disabled?: boolean;
    label: React.ReactNode;
    name: string;
    opensNewTab?: boolean;
    onClick?: () => void;
    showLabel?: boolean;
}

interface ButtonProps extends ButtonFactoryProps {
    buttonType?: string;
    isCollapsed?: boolean;
    isPrimary?: boolean;
    notCentered?: boolean;
    style?: React.CSSProperties;
    type?: string;
}

interface ButtonLinkStyleProps extends ButtonFactoryProps {
    hasSpacing?: boolean;
    isCollapsed?: boolean;
    isPrimary?: boolean;
}

interface TertiaryButtonProps extends ButtonFactoryProps {
    buttonType?: string;
    isCollapsed?: boolean;
    notCentered?: boolean;
}

const ButtonFactory: React.FC<ButtonFactoryProps> = ({className, disabled, label, name, opensNewTab, onClick}) => {

    return (
        <button
            className={className}
            data-testid={name}
            disabled={disabled || !onClick}
            formTarget={opensNewTab ? "_blank" : "_self"}
            id={name}
            onClick={onClick}
            type={"button"}
        >
            {label}
        </button>
    );
};

const Button: React.FC<ButtonProps> = (props) => {
    const {buttonType, className, isCollapsed, isPrimary, notCentered} = props;
    const classNames = getButtonClasses({className, isExpanded: !isCollapsed, isPrimary, buttonType, notCentered});
    return <ButtonFactory {...props} className={classNames}/>;
}

const ButtonLinkStyle: React.FC<ButtonLinkStyleProps> = (props) => {
    const {className, hasSpacing} = props;
    const classNames = getButtonClasses({className, hasSpacing, isLink: true});
    return <ButtonFactory {...props} className={classNames}/>;
}

const TertiaryButton: React.FC<TertiaryButtonProps> = (props) => {
    const {buttonType, className, isCollapsed, notCentered} = props;
    const classNames = getButtonClasses({className, isExpanded: !isCollapsed, isTertiary: true, buttonType, notCentered});
    return <ButtonFactory {...props} className={classNames}/>;
}

export {Button, ButtonLinkStyle, TertiaryButton};
